import { filter, find, get, includes } from 'lodash';
import { COLUMN_DATA_TYPE } from '../../../../shared/constants/list-view/cell-type.constant';
import { NON_FLAG_POINT_PEOPLE_TYPES } from '../../../../shared/constants/point-people-types.constant';
import { IListViewColumn } from '../../../../shared/typings/interfaces/list-view.interface';
import { IPointPerson } from '../../../../shared/typings/interfaces/student.interface';
import { IMyStudentsListStudent } from './../../../../store/effects/projections/my-students';
import { IMyStudentsMadlibModel } from './my-students-mad-lib.interface';

export const studentName: IListViewColumn = {
  human: 'Students',
  path: 'studentDetails.name.lastFirst',
  key: 'studentName',
  dataType: 'String',
  orderBy: 'asc',
  cellType: COLUMN_DATA_TYPE.SECTION_HEADER,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    const data = get(student, 'studentDetails.name.lastFirst');
    const studentId = get(student, 'studentId');
    const dependencies = { studentId };
    return { data, dependencies };
  },
};

export const attendanceFlags: IListViewColumn = {
  human: 'ATTENDANCE FLAGS',
  key: 'attendanceFlag',
  path: null,
  dataType: 'Array',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.FLAG,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    const data = get(student, 'attendanceFlags');
    const dependencies = {};
    return { data, dependencies };
  },
};

export const academicFlags: IListViewColumn = {
  human: 'ACADEMIC FLAGS',
  key: 'academicFlag',
  path: null,
  dataType: 'Array',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.FLAG,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    const data = get(student, 'academicFlags');
    const dependencies = {};
    return { data, dependencies };
  },
};

export const attendancePointPerson: IListViewColumn = {
  human: 'ATTENDANCE POINT PERSON',
  key: 'attendancePointPerson',
  path: null,
  dataType: 'String',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.POINT_PERSON,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    let person = find(student.pointPeople, (pointPerson: IPointPerson) => {
      return pointPerson.type === 'ATTENDANCE';
    });
    const fullName = person ? `${person.user.firstName} ${person.user.lastName}` : '\u2014';
    const data = fullName;
    const dependencies = {};
    return { data, dependencies };
  },
};

export const academicPointPerson: IListViewColumn = {
  human: 'ACADEMIC POINT PERSON',
  key: 'academicPointPerson',
  path: null,
  dataType: 'String',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.POINT_PERSON,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    let person = find(student.pointPeople, (pointPerson: IPointPerson) => {
      return pointPerson.type === 'ACADEMIC';
    });
    const fullName = person ? `${person.user.firstName} ${person.user.lastName}` : '\u2014';
    const data = fullName;
    const dependencies = {};
    return { data, dependencies };
  },
};

export const postsecondaryPointPerson: IListViewColumn = {
  human: 'POSTSECONDARY POINT PERSON',
  key: 'postSecondaryPointPerson',
  path: null,
  dataType: 'String',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.POINT_PERSON,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    let person = find(student.pointPeople, (pointPerson: IPointPerson) => {
      return pointPerson.type === 'POSTSECONDARY';
    });
    const fullName = person ? `${person.user.firstName} ${person.user.lastName}` : '\u2014';
    const data = fullName;
    const dependencies = {};
    return { data, dependencies };
  },
};

export const otherStaff: IListViewColumn = {
  human: 'OTHERS',
  key: 'otherStaff',
  path: null,
  dataType: 'Number',
  orderBy: 'desc',
  cellType: COLUMN_DATA_TYPE.OTHER_STAFF,
  cellConfig: {},
  getValueAtPath: (student: IMyStudentsListStudent, madLibModel: IMyStudentsMadlibModel, listType: string) => {
    const { pointPeople, otherStaff } = student;
    const nonFlagPP = filter(pointPeople, (person: IPointPerson) => {
      return includes(NON_FLAG_POINT_PEOPLE_TYPES, person.type);
    });
    let data = otherStaff ? otherStaff : [];
    data = [...nonFlagPP, ...data];
    const dependencies = {};
    return { data, dependencies };
  },
};
